module.exports = __webpack_public_path__ + "img/project9_14.png.fa6f05e6.webp";